import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table columns2 w-full" }
const _hoisted_2 = { class: "tasks-grid" }
const _hoisted_3 = { class: "pad-s" }
const _hoisted_4 = { class: "mleft-06 w-full" }
const _hoisted_5 = { class: "row gap-04 w-full" }
const _hoisted_6 = {
  key: 1,
  class: "row w-full"
}
const _hoisted_7 = { class: "row categories-grid" }
const _hoisted_8 = { class: "w-full h-full mleft-auto pad-s" }
const _hoisted_9 = { class: "colend w-full mleft-04 mright-04" }
const _hoisted_10 = { class: "row gap-04" }
const _hoisted_11 = {
  key: 0,
  class: "row w-full"
}
const _hoisted_12 = { style: {"margin-left":"auto"} }
const _hoisted_13 = {
  key: 1,
  class: "row"
}
const _hoisted_14 = {
  key: 0,
  class: "item-modal"
}
const _hoisted_15 = {
  key: 1,
  class: "item-modal"
}

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import editTask from './editTask.vue';
import { apiDate, apiDateString } from '@/api/apicommon';
import { getTaskBoxTitle, getTaskBoxIcon } from '@/functions/office';
import { useAppUserStore } from '@/stores/appUser';
import taskNotesRename from './taskNotesRename.vue';
import { formatUTCDateTimeToDate, formatUTCDateTimeToTime } from '@/utils/date-utils';
import { TaskPriorityChange, TaskStatus, TaskStatusChange } from '@/models/task.model';
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'taskCard',
  props: {
  task: {
    type: Object,
    required: true,
  },
  tasks: {
    type: Array,
    required: false,
  },
  showPatient: {
    type: Boolean,
    default: true,
  },
  isTransparent: {
    type: Boolean,
    default: false,
  }
},
  emits: ['changed', 'changeShowDate'],
  setup(__props, { emit: __emit }) {

const appUserStore = useAppUserStore()
const { t } = useI18n();

const props = __props;

const taskPriorityChange = ref<TaskPriorityChange>(undefined);
const taskStatusChange = ref<TaskStatusChange>(undefined);

const emits = __emit
const currTaskBox = computed(() => {
  return props.task.taskBox;
})

function getDateTimeString(dateIso) {
  const today = new Date()
  const comparisonDate = new Date(dateIso)
  today.setHours(0, 0, 0, 0)
  comparisonDate.setHours(0, 0, 0, 0)
  return comparisonDate < today
    ? formatUTCDateTimeToDate(dateIso)
    : formatUTCDateTimeToTime(dateIso)
}

function getPriorityTerm(task) {
  if (task.taskBox) {
    return t(`task.taskPriority.${task.taskPriorityType}`)
  } else {
    return t(`task.notePriority.${task.taskPriorityType}`)
  }
}

function showFormattedDate(isoDateString) {
  const locale = 'de-DE'
  const options = { day: '2-digit', month: '2-digit', year: 'numeric' }
  const showDate = new Date(isoDateString);
  return showDate.toLocaleDateString(locale, options);
}

const taskBoxTerm = computed(() => {
  if (props.task.patientNoteType !== 'None'){
    if (['Administrative', 'Healthcare'].includes(props.task.patientNoteType)) {
      return t('settings.params.tasks.patientnote');
    } else {
      return props.task.patientNoteType;
    }
  } 
  const taskBox = currTaskBox.value
  const taskBoxList = appUserStore.taskBoxList
  return getTaskBoxTitle(taskBox, taskBoxList, appUserStore.currentHealthGroupMembership.pwr)
})

const taskBoxIcon = computed(() => {
  return getTaskBoxIcon(currTaskBox.value);
})

let pendingOps: Promise<unknown>[] = [];

function trackPendingOp(promise: Promise<unknown> | undefined) {
  if (promise) { pendingOps.push(promise); }
  if (props.task.taskStatus === 'Rename') {
    taskStatusChange.value = {
      newStatus: TaskStatus.Pending,
      oldStatus: TaskStatus.Rename,
    };
  }
}

const setStatusDataChange = (newStatusChange: TaskStatusChange) => {
  taskStatusChange.value = newStatusChange;
  if (!taskPriorityChange.value) {
    taskPriorityChange.value = {
      newPriority: newStatusChange.taskPriority,
      oldPriority: newStatusChange.taskPriority
    };
  }
}

const setPriorityDataChange = (data: TaskPriorityChange) => {
  taskPriorityChange.value = data;
}

async function onModalClose() {
  if (pendingOps.length) {
    for (const pendingOp of pendingOps) {
      await pendingOp;
    }
    pendingOps = [];
    emits('changed', {taskPriorityChange: taskPriorityChange.value, taskStatusChange: taskStatusChange.value});
  } else if (taskStatusChange.value) {
     emits('changed', {taskPriorityChange: taskPriorityChange.value, taskStatusChange: taskStatusChange.value});
  }

  taskPriorityChange.value = undefined;
  taskStatusChange.value = undefined;
}

const firstTaskNote = computed(() => {
  return props.task.taskNotes[0]
})

const lastTaskNote = computed(() => {
  if (props.task.taskNotes.length === 1) return null;
  if (props.task.taskNotes.length <= 2 && props.task.originalExpression !== '') return null;
  return props.task.taskNotes.at(-1)
})

const isRedTask = computed(() => {
  return props.task.taskPriorityType === 'DuringShift' && props.task.taskStatus === 'Pending' && !(props.task.showDateTime && apiDate(props.task.showDateTime) > new Date())
})

const unreadTaskNotes = computed(() => {
  const count = props.task.taskNotes.filter(tn => tn.read === false).length
  return count ? count.toString() : ""
})

const patientName = computed(() => {
  const pwr = props.task.pwrPatient
  return PersonService.formatName(pwr.lastName, pwr.firstName);
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_itemModal = _resolveComponent("itemModal")!

  return (_openBlock(), _createBlock(_component_itemModal, {
    uiId: 'EditTaskCategories' + __props.task.taskId,
    onClose: onModalClose
  }, {
    modal: _withCtx(() => [
      (__props.task.taskStatus === 'Rename')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(taskNotesRename, {
              task: __props.task,
              tasks: __props.tasks,
              onChanged: trackPendingOp
            }, null, 8, ["task", "tasks"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(editTask, {
              task: props.task,
              hasInputTaskNote: false,
              canChangePatient: false,
              onChanged: trackPendingOp,
              onChangedPriority: _cache[0] || (_cache[0] = ($event: any) => (setPriorityDataChange($event))),
              onChangedStatus: _cache[1] || (_cache[1] = ($event: any) => (setStatusDataChange($event))),
              onChangeShowDate: _cache[2] || (_cache[2] = ($event: any) => (emits('changeShowDate')))
            }, null, 8, ["task"])
          ]))
    ]),
    default: _withCtx(() => [
      _createVNode(_component_buttonGroup, { styles: "pad-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (props.isTransparent)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["bg-card columns2-content", {'task-alert': isRedTask.value}])
                }, null, 2))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["bg-card task", {'task-alert': isRedTask.value}])
                }, null, 2)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (props.task.pwrPatient && props.showPatient)
                    ? (_openBlock(), _createBlock(_component_text_item, {
                        key: 0,
                        txt: patientName.value
                      }, null, 8, ["txt"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_5, [
                    (__props.task.originalExpression !== '')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_text_item, {
                            txt: __props.task.originalExpression,
                            class: "text-max-w"
                          }, null, 8, ["txt"]),
                          (__props.task.resultDate)
                            ? (_openBlock(), _createBlock(_component_text_item, {
                                key: 0,
                                txt: "du"
                              }))
                            : _createCommentVNode("", true),
                          (__props.task.resultDate)
                            ? (_openBlock(), _createBlock(_component_text_item, {
                                key: 1,
                                txt: showFormattedDate(__props.task.resultDate)
                              }, null, 8, ["txt"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createBlock(_component_text_item, {
                          key: 1,
                          txt: firstTaskNote.value.noteContent,
                          class: "ellipsis text-max-w"
                        }, null, 8, ["txt"]))
                  ]),
                  (lastTaskNote.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_text_item, {
                          txt: lastTaskNote.value.appUserNoteCreator.firstName + ': ',
                          styles: "main-m"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: lastTaskNote.value.noteContent,
                          class: "mleft-02 text-max-w",
                          styles: "main-m"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: getDateTimeString(lastTaskNote.value.created),
                          styles: "font-s main-m",
                          class: "mleft-auto psides-04"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: unreadTaskNotes.value,
                          styles: "font-mBold",
                          class: "mleft-04"
                        }, null, 8, ["txt"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (!currTaskBox.value && props.task.hasAlert)
                      ? (_openBlock(), _createBlock(_component_svg_item, {
                          key: 0,
                          icon: "bell",
                          styles: "main-m size-s",
                          class: "mtop-01"
                        }))
                      : _createCommentVNode("", true),
                    (!currTaskBox.value && props.task.isPrivate)
                      ? (_openBlock(), _createBlock(_component_svg_item, {
                          key: 1,
                          icon: "lock",
                          styles: "main-m size-s"
                        }))
                      : _createCommentVNode("", true),
                    (currTaskBox.value && currTaskBox.value.taskBoxChannelType !== 'TwoPerson')
                      ? (_openBlock(), _createBlock(_component_svg_item, {
                          key: 2,
                          icon: taskBoxIcon.value,
                          styles: "size-s main-m"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_text_item, {
                      txt: taskBoxTerm.value,
                      class: "mtop-01 task-box-term",
                      styles: "main-m font-s"
                    }, null, 8, ["txt"])
                  ]),
                  (__props.task.taskStatus === 'Settled')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_text_item, {
                            txt: 'Validé: ' + getDateTimeString(__props.task.updated),
                            styles: "font-s main-m"
                          }, null, 8, ["txt"])
                        ])
                      ]))
                    : (props.task.showDateTime && _unref(apiDate)(props.task.showDateTime) > new Date())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_svg_item, {
                            icon: "calendar",
                            styles: "main-m size-s",
                            style: {"margin-top":"-0.25rem"}
                          }),
                          _createVNode(_component_text_item, {
                            txt: _unref(apiDateString)(props.task.showDateTime),
                            styles: "main-m font-s",
                            class: "mleft-04 mtop-02"
                          }, null, 8, ["txt"])
                        ]))
                      : (_openBlock(), _createBlock(_component_text_item, {
                          key: 2,
                          txt: getPriorityTerm(props.task),
                          class: "mtop-02",
                          styles: "main-m font-s"
                        }, null, 8, ["txt"]))
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["uiId"]))
}
}

})